import { render, staticRenderFns } from "./serviceAear.component.vue?vue&type=template&id=3c7ef244&scoped=true&"
import script from "./serviceAear.component.vue?vue&type=script&lang=js&"
export * from "./serviceAear.component.vue?vue&type=script&lang=js&"
import style0 from "./serviceAear.component.vue?vue&type=style&index=0&id=3c7ef244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ef244",
  null
  
)

export default component.exports